
import {
  Col,
  Container,
  Row,
} from 'reactstrap';

const CardLoading = () => {
  const initialLoading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

  return (
    <Container fluid className="page-container" style={{ padding: 0,minHeight:500, display:'flex',alignItems:'center',flexDirection:'row', margin: '0px' }}>
      <Row>
        {
          initialLoading.map((item, index) => (
            <Col key={index} md={4} lg={3} xs={6} className="is__progresss">
              <div className="is__progresss_header">
                <div className="item_top" />
              </div>
              <div className="is__progresss_center">
                <h3 style={{ visibility: 'hidden' }}>Image</h3>
              </div>
              <div className="is__progresss_footer">
                <h3 style={{ visibility: 'hidden' }}>Title</h3>
              </div>
            </Col>
          ))
        }
      </Row>
    </Container>
  )
}
export default CardLoading;
